import { useCallback } from 'react'
import { useCreateDocumentVersionSessionEvent } from '@/services/queries/document_sessions'
import { useUpdateDocumentVersionSessionEvent } from '@/services/queries/document_sessions'
import { useTechnicianPageStore } from './useTechnicianPageStore'

export const useCreateSessionEvent = () => {
  const { mutateAsync: createEvent } = useCreateDocumentVersionSessionEvent()
  const { mutateAsync: updateEvent } = useUpdateDocumentVersionSessionEvent()

  const createSessionEvent = useCallback(
    async ({
      documentPageId,
      buttonLabel,
      completeLastEvent = true,
      completedTimestamp,
      subPageIndex,
      onSuccess,
    }: {
      documentPageId: string
      buttonLabel: string
      completeLastEvent?: boolean
      completedTimestamp?: string
      subPageIndex?: number
      onSuccess?: () => void
    }) => {
      const {
        currentSessionId: activeSessionId,
        lastSessionEventId: activeLastSessionEventId,
      } = useTechnicianPageStore.getState()

      const shouldCompleteEvent =
        activeLastSessionEventId && completeLastEvent && !completedTimestamp

      if (activeSessionId) {
        // React Query mutation scope serializes these writes across hooks.
        await createEvent({
          documentPageId,
          documentVersionSessionId: activeSessionId,
          buttonLabel,
          completedTimestamp,
          subPageIndex,
        })

        if (shouldCompleteEvent) {
          await updateEvent({
            documentVersionSessionEventId: activeLastSessionEventId,
            completedTimestamp: new Date().toISOString(),
            subPageIndex,
          })
        }

        if (typeof onSuccess === 'function') {
          onSuccess()
        }
      }
    },
    [createEvent, updateEvent],
  )

  return {
    createSessionEvent,
  }
}
